import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdChoferFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [choferes, setChoferes] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.CHOFER).then(({ data }) => {
      setChoferes(data)
    })
  }, [])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.CHOFER).then(({ data }) => {
      setChoferes(data)
    })
    setMostrarModalCrud(false)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='CHOFER' htmlFor='select-idChofer' md={4} alignRightAt='md' />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='_idChofer'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idChofer'>
                  <option key='seleccionar' value=''>
                    Seleccionar
                  </option>
                  {choferes.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.CHOFER}
        />
      )}
    </>
  )
}

export default React.memo(IdChoferFormGroup)
